var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFetchPackageLogoFullWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400.07 332.63",
    style: {
      enableBackground: "new 0 0 400.07 332.63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#E02828;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -99.65,
    y: -42.39,
    className: "st1",
    width: 614.17,
    height: 420.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Dog_V2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "290.12,62.55 260.11,21.33 250.85,25.49 283.63,71.22  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251,28.91c-15.27,7.27-31.97,13.2-51.6,17.57c-40.27,8.96-76,1.51-95.24,13.82 c-16.6,10.62-26.61,37.87-29.37,45.05c-15.78,41.14-36.14,36.67-41.04,41.42c-3.34,3.23-1.05,3.19-6.02,12.3 c-5.15,9.44-23.5,28.46-20.05,37.4c3.53,9.14,13.81,18.14,20.54,12.19c6.29-5.56-7.44-15.86-6.12-19.79 c0.69-2.07,11.92-21.52,23.17-24.5c10.05-2.66,28.63-6.62,45.19-21.28c14.18-12.55,15.22-25.06,43.19-34.97 c17.69-6.27,74.32,12.06,76.22,14.19c3.77,4.22,6.27,66.29,19.28,78.46c10.7,10.01,23.25,7.54,23.41,4.88 c0.65-11.09-9.87-10.01-13.69-18.12c-7.24-15.38-7.41-58.41-3.21-70.29c1.55-4.4,17.82-6.66,33.12-23.95 c7.36-8.31,9.56-16.84,11.79-23.07L251,28.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.66,135.82c4.63-6.44,7.74-15.53,9.17-24.31c-5.55-0.89-10.82-1.44-15.33-1.44 c-3.73,0-6.67,0.37-8.75,1.11c-5.77,2.04-10.3,4.17-14.03,6.38c0.36,4.28,0.45,8.16-0.18,10.52 c-6.87,25.68-21.46,29.86-21.56,36.44c-0.08,5.49,7.12,9.59,14.5,19.23c4.05,5.29,8.64,12.58,14.86,15.39 c4.76,2.15,19.82,3.12,19.5-2.01c-0.23-3.71-4.8-9.38-9.04-9.62c-6.48-0.38-19.35-13.37-17.31-20.47 C125.59,152.77,142.96,145.14,149.66,135.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.53,86.5c-1.6,2.92-3.62,5.93-6.28,8.93c-1.98,2.23-3.96,4.22-5.93,6c6.9-1.04,14.08-1.46,15,1.55 c1.55,5.09-12.26,13.94-14.27,17.85c-2.01,3.91-1.42,11.7,1.57,14.8c1.79,1.85,7.96-0.43,9.67-3.98 c1.98-4.11,24.54-28.39,20.85-37.85C295.59,87.28,288.21,86.6,277.53,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M327.15,43.17l0.27-1.75l1.72-0.46c0.53-0.14,1.02-0.28,1.32-0.36l0.3-0.08c0.36-0.1,0.74-0.14,1.12-0.14 c1.3,0,2.53,0.54,3.94,1.17c2.18,0.96,5.16,2.29,9.77,2.29c3.61,0,7.7-0.82,12.17-2.44l0.42-0.15c3.33-5.18,5.11-10.44,4.29-12.96 c-0.46-1.41-2.48-2.81-5.2-4.13c-6.39-3.1-16.66-5.8-19.76-7.41c-2.28-1.18-3.89-3.15-5.4-6.3c-2.8-5.78-29.65-13.21-35.02-9.38 C285.97,9,274.96,16.21,263.3,22.6l26.26,36c5.58-4.61,14.12-10.4,25.8-9.93c3.66,0.15,6.99,2.49,10.1,5.39L327.15,43.17z  M310.11,23.02c-0.83,3.39,1.74,7.17,0.51,11.36c-2.12,7.23-11.47,14.02-14.9,15.45c-11.92,4.97-15.99-16.25-16.01-24.58 c-0.01-2.77,6.08-10.37,7.32-10.38c0.29,0-6.25,7.71-5.47,12.1c0.86,4.86,3.71,20.42,10.06,19.89c3.21-0.27,12.81-5.48,15.44-11.62 c2.02-4.72,0.02-8.95,1.15-12.48c2.47-7.68,5.35-7.9,5.76-7.9C315.75,14.87,312.09,14.96,310.11,23.02z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387.49,52.83l10.54-3.04l-39.34-5.84c-3.29,1.19-6.17,1.9-8.72,2.27L387.49,52.83z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "386.51,54.5 329.7,44.48 325.11,74.15 381.18,88.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "382.06,89.19 382.06,89.19 382.07,89.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "388.35,54.47 383.16,88.07 397.16,73.71 400.07,51.08  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.18,78.76c26.77,9.81,36.36,2.73,48.7-5.44c4.3-6.16,9.42-11.82,15.36-15.62c0.43-0.28,0.89-0.53,1.34-0.79 c-13.75-0.44-38.63-0.7-58.76-4.25c-17.57-3.1-41.19-7.48-45.23-4.41C-3.05,51,10.24,68.15,39.18,78.76z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 360.98,
    y1: 36.07,
    x2: 360.98,
    y2: 36.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "360.98,36.07 360.99,36.07 360.98,36.07  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 285.42,
    y1: 175.56,
    x2: 285.42,
    y2: 175.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "285.42,175.56 285.42,175.56 285.42,175.56  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "FETCH__LOGOTYPE"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.84,230.28c-3.56-0.93-7.12-1.55-10.07-1.55c-6.5,0-8.83,3.1-8.83,9.14v5.57H76v16.1H56.49v71.38H33.11 v-71.38H20.26v-16.1h13.32v-6.19c0-14.55,9.6-27.41,31.28-27.41c6.35,0,10.53,0.62,14.24,1.55L75.84,230.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.8,322.88c-6.81,5.57-15.33,9.76-32.05,9.76c-27.56,0-41.65-15.48-41.65-45.68 c0-28.34,15.79-45.21,41.03-45.21c22.3,0,35.15,14.09,35.15,35.46c0,4.49-0.15,8.83-1.08,15.64h-52.18 c0.31,13.78,6.5,21.37,21.37,21.37c9.45,0,15.95-4.49,19.2-7.9L152.8,322.88z M102.47,277.35h30.81v-3.25 c-0.31-9.6-4.65-14.71-13.78-14.71C108.98,259.39,102.78,267.14,102.47,277.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172,302.9v-41.65h-11.15V246.7l11.3-4.65l8.05-20.59h14.86v21.99h21.83v17.81h-21.83v42.27 c0,6.04,3.41,9.14,9.14,9.14c3.71,0,8.52-1.24,11.92-3.87l6.04,17.49c-2.94,2.17-9.76,5.42-24.31,5.42 C182.84,331.7,172,324.12,172,302.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.14,241.74c14.09,0,24.31,4.8,30.19,12.7l-15.64,14.86c-1.24-2.17-5.73-8.36-14.55-8.36 c-10.07,0-16.57,6.2-16.57,25.24c0,18.58,5.42,27.25,16.41,27.25c7.74,0,12.7-4.64,14.86-8.52l14.86,13.78 c-4.95,6.66-13.32,13.93-31.9,13.93c-23.69,0-38.09-13.01-38.09-44.59C225.73,257.23,242.45,241.74,266.14,241.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M380.26,271.93v58.99h-23.38v-54.35c0-9.29-4.18-13.94-12.08-13.94c-5.57,0-12.08,4.18-15.02,9.6v58.68 H306.4V213.56h23.38v38.71h0.62c4.95-5.11,13.01-9.45,23.07-9.45C370.5,242.83,380.26,252.27,380.26,271.93z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetchPackageLogoFullWhite);
export default __webpack_public_path__ + "static/media/fetch-package-logo-full-white.c97db9bb6290484109e40f62c7645c1d.svg";
export { ForwardRef as ReactComponent };